import { render, staticRenderFns } from "./AddRom.vue?vue&type=template&id=b4c67274&scoped=true"
import script from "./AddRom.vue?vue&type=script&lang=js"
export * from "./AddRom.vue?vue&type=script&lang=js"
import style0 from "./AddRom.vue?vue&type=style&index=0&id=b4c67274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c67274",
  null
  
)

export default component.exports